export default function Footer() {
  const footerLinks = [
    {
      title: '内容板块',
      links: [
        { label: '焦点速递', href: '#carousel' },
        { label: '专题合集', href: '#index' },
        { label: '吃瓜榜单', href: '#ranking' },
        { label: '深度解读', href: '#cards' },
      ],
    },
    {
      title: '平台信息',
      links: [
        { label: '关于我们', href: '#about' },
        { label: '常见问题', href: '#faq' },
        { label: '投稿爆料', href: '#contact' },
        { label: '最新动态', href: '#updates' },
      ],
    },
    {
      title: '互动社区',
      links: [
        { label: '瓜友热评', href: '#comments' },
        { label: '热门话题', href: '#topics' },
        { label: '精彩视频', href: '#media' },
        { label: '移动端', href: '#app' },
      ],
    },
  ];

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-white text-base">🍉</span>
              <span className="text-xl font-heading text-white whitespace-nowrap">今日吃瓜</span>
            </a>
            <p className="text-background-400 text-sm leading-relaxed mb-4">
              今日吃瓜是国内领先的娱乐资讯与热点话题聚合平台。我们覆盖娱乐圈、影视综艺、音乐、电竞、社会热点等多个领域，每日更新吃瓜大全资源，批量瓜料一站尽收。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-white font-semibold text-sm mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-background-400 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 pt-8 mb-8">
          <h3 className="text-white font-semibold text-sm mb-4">合作伙伴</h3>
          <div className="flex flex-wrap gap-4">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div
                key={i}
                className="h-10 w-28 rounded-lg bg-background-800 flex items-center justify-center text-background-500 text-xs"
              >
                合作伙伴
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 今日吃瓜 · 每日大赛与合集汇总平台 · 版权所有
          </p>
          <p className="text-background-500 text-xs">
            本站内容仅供娱乐交流，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}